import React from "react";
import { format } from "date-fns";
import { Grid } from "@material-ui/core";
import "./styles.css";

const Header = props => {
  const {
    companyName,
    companyPrimaryColor,
    dealId,
    dealName,
    textColor,
    refiType
  } = props;

  const currentDate = format(new Date(), "MMMM dd, yyyy");

  return (
    <Grid container item direction="row">
      <div className="pdf-export-header-wrapper" style={{ backgroundColor: companyPrimaryColor, color: textColor }}>
        <div className="pdf-export-header-company-name">{companyName}</div>
        <div className="pdf-export-header-right-cluster-wrapper">
          <div>
            {`${dealId ? `${dealName} - ` : ""}`}
            {refiType}
          </div>
          <div>{currentDate}</div>
        </div>
      </div>
    </Grid>
  );
};

export default Header;
